import { doToast } from './toast'

export const defaultToast = () => {
  return { response: 'error', message: 'No se ha podido realizar la conexión al servidor. Contacte con el área de IT.' }
}

export const promiseCatch = ({
  req = {}, toast
}) => {
  if (req.response) {
    doToast({ response: req.response, message: req.message, toast })
  } else {
    doToast({ ...defaultToast(), toast })
  }
}